import { idColumn } from '@/shared/grids/columns/idColumn';
import { textColumn } from '@/shared/grids/columns/textColumn';
import { GridSettings } from '@/shared/types/grid';

import { Form } from '@prisma/client';

export const formGrid: GridSettings<Form> = {
  defaultSort: {
    name: 'asc',
  },
  columns: [
    idColumn(),
    textColumn({
      header: 'Form',
      field: 'name',
      allowFiltering: false,
    }),
  ],
};
